/**
 * PDP Image Lightbox — click any gallery image to open fullscreen viewer.
 * Arrow keys + swipe + close button. Desktop: optional hover-zoom inside lightbox.
 */
(function () {
  var mainImg = document.getElementById('pdp-main-img');
  var thumbs = document.querySelectorAll('.pdp-top__thumb');
  if (!mainImg) return;

  // Build images list from thumbs (or fall back to main img)
  var images = [];
  if (thumbs.length > 0) {
    thumbs.forEach(function (t) {
      images.push({
        src: t.dataset.thumbSrc,
        alt: t.dataset.thumbAlt || ''
      });
    });
  } else {
    images.push({ src: mainImg.src, alt: mainImg.alt });
  }

  var i18nEl = document.getElementById('lightbox-i18n');
  var i18n = {
    viewer: (i18nEl && i18nEl.getAttribute('data-i18n-image-viewer')) || 'Image viewer',
    close:  (i18nEl && i18nEl.getAttribute('data-i18n-close'))        || 'Close',
    prev:   (i18nEl && i18nEl.getAttribute('data-i18n-prev'))         || 'Previous image',
    next:   (i18nEl && i18nEl.getAttribute('data-i18n-next'))         || 'Next image'
  };

  var overlay = document.createElement('div');
  overlay.className = 'pdp-lightbox';
  overlay.setAttribute('role', 'dialog');
  overlay.setAttribute('aria-modal', 'true');
  overlay.setAttribute('aria-label', i18n.viewer);
  overlay.hidden = true;
  overlay.innerHTML =
    '<button type="button" class="pdp-lightbox__close" aria-label="' + i18n.close + '">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
    '</button>' +
    '<button type="button" class="pdp-lightbox__prev" aria-label="' + i18n.prev + '">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><polyline points="15 18 9 12 15 6"/></svg>' +
    '</button>' +
    '<button type="button" class="pdp-lightbox__next" aria-label="' + i18n.next + '">' +
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><polyline points="9 6 15 12 9 18"/></svg>' +
    '</button>' +
    '<div class="pdp-lightbox__stage"><img class="pdp-lightbox__img" alt=""></div>' +
    '<div class="pdp-lightbox__counter"><span class="pdp-lightbox__current">1</span> / <span class="pdp-lightbox__total">1</span></div>';
  document.body.appendChild(overlay);

  var img = overlay.querySelector('.pdp-lightbox__img');
  var currentEl = overlay.querySelector('.pdp-lightbox__current');
  var totalEl = overlay.querySelector('.pdp-lightbox__total');
  var idx = 0;

  function show(i) {
    if (i < 0) i = images.length - 1;
    if (i >= images.length) i = 0;
    idx = i;
    img.src = images[i].src;
    img.alt = images[i].alt;
    currentEl.textContent = i + 1;
  }

  function open(i) {
    totalEl.textContent = images.length;
    show(i || 0);
    overlay.hidden = false;
    document.body.classList.add('pdp-lightbox-open');
    document.addEventListener('keydown', onKey);
  }

  function close() {
    overlay.hidden = true;
    document.body.classList.remove('pdp-lightbox-open');
    document.removeEventListener('keydown', onKey);
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowLeft') show(idx - 1);
    else if (e.key === 'ArrowRight') show(idx + 1);
  }

  overlay.querySelector('.pdp-lightbox__close').addEventListener('click', close);
  overlay.querySelector('.pdp-lightbox__prev').addEventListener('click', function () { show(idx - 1); });
  overlay.querySelector('.pdp-lightbox__next').addEventListener('click', function () { show(idx + 1); });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay || e.target.classList.contains('pdp-lightbox__stage')) close();
  });

  // Touch swipe
  var touchStartX = 0;
  overlay.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
  overlay.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) show(dx < 0 ? idx + 1 : idx - 1);
  }, { passive: true });

  // Open when clicking the main image
  mainImg.style.cursor = 'zoom-in';
  mainImg.addEventListener('click', function () {
    // Prefer the active thumb — set by the swap script, exact index match.
    var activeThumb = document.querySelector('.pdp-top__thumb.is-active');
    if (activeThumb) {
      var thumbArr = Array.prototype.slice.call(thumbs);
      var idx = thumbArr.indexOf(activeThumb);
      if (idx >= 0) { open(idx); return; }
    }
    // Fall back to URL match (page load with no active class yet, or no thumbs).
    var currentSrc = mainImg.src;
    var found = images.findIndex(function (im) { return im.src === currentSrc; });
    open(found >= 0 ? found : 0);
  });

  // Open when clicking a thumb with cmd/ctrl (optional) — default behaviour still swaps
  // Skip: keep existing thumb swap behaviour
})();
